import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { NotepadQuestionForm } from '../models/notepad-form.model';
import { NotepadQuestion } from '../models/notepad-model.model';

@Injectable({
  providedIn: 'root'
})
export class NotepadService {
  getQuestionForm(question: NotepadQuestion): FormGroup {
    const cards = [];
    const options = [];

    question.cards?.forEach((card) => {
      cards.push(new FormControl(card, [Validators.required]));
    });

    question.options?.forEach((option) => {
      options.push(new FormControl(option, [Validators.required]));
    });

    question.ranks?.forEach((rank) => {
      options.push(new FormControl(rank, [Validators.required]));
    });

    const form = new FormGroup(new NotepadQuestionForm(question));

    return form;
  }
}
